import { PHYSICAL_DIRECTIONS } from 'src/utils/physical-api';

export const AREA_DELIVERY_OPTIONS = [
  {
    value: 'NY_Delivery',
    label: 'NY Delivery',
    direction: PHYSICAL_DIRECTIONS.GE_USA,
    cityPlaceholder: 'New York, NY',
    mapCenter: { lat: 40.7128, lng: -74.006 },
  },
  {
    value: 'Tbilisi_Delivery',
    label: 'Tbilisi Delivery',
    direction: PHYSICAL_DIRECTIONS.USA_GE,
    cityPlaceholder: 'Tbilisi',
    mapCenter: { lat: 41.7151, lng: 44.8271 },
  },
];

export const AREA_DELIVERY_LABELS = Object.fromEntries(
  AREA_DELIVERY_OPTIONS.map((option) => [option.value, option])
);

export const AREA_DELIVERY_TYPES = AREA_DELIVERY_OPTIONS.map((option) => option.value);
